import React, { Component } from 'react';

import Loading from './Loading';
import './Grid.css';

import turf from '@turf/turf';
import PolygonLookup from 'polygon-lookup';

import ReactDOMServer from 'react-dom/server';

const propTypes = {};

const defaultProps = {};

class Grid extends Component {
  constructor(props) {
    super(props);
    this.state = props;
    this.getBounds = this.getBounds.bind(this);
  }

  componentWillReceiveProps(nextProps) {      
    this.setState(() => {
      return { map: nextProps.map, zoom: nextProps.zoom, readings: nextProps.readings, metric: nextProps.metric, loading: nextProps.loading, mapboxgl: nextProps.mapboxgl };
    },
    () => {
      const { map, metric, readings } = this.state;
      const grid = this.updateGrid(map, metric);
      this.applyAverages(map, grid, metric, readings);
    });

    nextProps.map.on('dragend',()=>{
      const grid = this.updateGrid(nextProps.map, nextProps.metric);
      this.applyAverages(nextProps.map, grid, nextProps.metric, nextProps.readings);
    });

    nextProps.map.on('moveend', () => {
      const grid = this.updateGrid(nextProps.map, nextProps.metric);
      this.applyAverages(nextProps.map, grid, nextProps.metric, nextProps.readings);
    });

    this.setState(() => {
      return { zoom: nextProps.zoom };
    });
  }

  getBounds(map) {
    const minX = 0;
    const minY = 0;
    const maxX = window.innerWidth;
    const maxY = window.innerHeight;

    const topleft = map.unproject([minX, minY]).toArray();
    const topright = map.unproject([maxX, minY]).toArray();
    const bottomleft = map.unproject([minX, maxY]).toArray();
    const bottomright = map.unproject([maxX, maxY]).toArray();

    const boundingbox = turf.featureCollection([turf.point(topleft), turf.point(topright), turf.point(bottomleft), turf.point(bottomright)]);

    return turf.bbox(boundingbox);
  }

  getPolygon(bbox) {
    return turf.bboxPolygon(bbox);
  }

  generateSquareGrid(polygon, map) {
    const size = Math.pow(2, (20 - map.getZoom())) / 512;
    //const size = 0.02;
    const grid = turf.hexGrid(polygon, size, 'kilometers', false);
    return grid;
  }

  getAverage(grid, metric, readings) {      
    const newfeatures = grid.features.map((feature, index) => {
      const newfeature = feature;
      newfeature.properties.index = index;
      return newfeature;
    });

    grid.features = newfeatures;

    if (!readings) {
      return null;
    }

    let averageGrid = [];
    const currentReadings = readings;
    const lookup = new PolygonLookup(grid);

    currentReadings.map((reading, index) => {
      const container = lookup.search(reading.long, reading.lat);
      
      
      if (container !== undefined) {                        

        let exists = false;
        averageGrid = averageGrid.map((gridcell) => {
          if (container.properties.index === gridcell.properties.index) {
            if(metric === "wind"){
              gridcell.properties.sum += ( reading['wv'] + reading['wh'])/2
            }else{                                          
              gridcell.properties.sum += reading[metric];
            }
            gridcell.properties.numbers += 1;
            exists = true;
          }
          return gridcell;
        });

        if (!exists) {
          if(metric === "wind"){
              container.properties.sum = ( reading['wv'] + reading['wh'])/2
            }else{                                          
              container.properties.sum = reading[metric];
            }
          container.properties.numbers = 1;
          averageGrid.push(container);
        }
      }
      return undefined;
    });

    let max = 0;
    let min = 10000;
    const newGrid = [];
    averageGrid.forEach((gridcell) => {
      if (gridcell.properties.sum > 0) {
        gridcell.properties.average = gridcell.properties.sum / gridcell.properties.numbers;
          
        if (gridcell.properties.average > max ) {
          max = gridcell.properties.average;
        }
        if (gridcell.properties.average < min) {
          min = gridcell.properties.average;
        }

        newGrid.push(gridcell);
      }
      if (gridcell.properties.sum === null) {
        gridcell.properties.average = null;
        newGrid.push(gridcell);
      }
    });
    averageGrid = newGrid;
    averageGrid = turf.featureCollection(averageGrid);

    this.setState(() => {
      return { 'averageGrid': averageGrid, 'max': max, 'min':min };
    });

    return [averageGrid, max, min];
  }

  updateGrid(map, metric) {
    const bounds = this.getBounds(map);
    const squareGrid = this.generateSquareGrid(bounds, map);
    this.setState(() => {
      return { 'squareGrid': squareGrid };
    });
    return squareGrid;
  }

  applyAverages(map, squareGrid, metric, readings) {
    
    if (this.state.popup) {
      this.state.popup.remove();
    }
    
    if (readings) {
      const average = this.getAverage(squareGrid, metric, readings);
      const averageGrid = average[0];
      const max = average[1];
      const min = average[2];
      const range = Math.abs(max - min);
      const segment = range / 5;
      const stops = {
                property: 'average',
                stops: [
                    [min, '#fee0b6'],
                    [min + segment, '#db9276'],
                    [min + 2 * segment, '#ef7d51'],
                    [min + 3 * segment, '#ad3416'],
                    [max - segment, '#b31817']                    
                ]
              }; 
      
      try {
      //map.removeSource('averages');
      //map.removeLayer('average-grid');
        map.getSource('averages').setData(averageGrid)
        map.setPaintProperty('average-grid', 'fill-color', stops)
      } catch (err) {      
      
      
        this.setState(() => {
          return { segment: segment, averageGrid: averageGrid }
        })

        if (averageGrid.features.length > 0) {
          if (max > min && segment < max) {
            map.addSource(
              'averages', {
                type: 'geojson',
                data: averageGrid,
              },
            );

            map.addLayer({
              id: 'average-grid',
              type: 'fill',
              source: 'averages',                
              paint: {
                'fill-color': {
                  property: 'average',
                  stops: [
                      [min, '#fee0b6'],
                      [min + segment, '#db9276'],
                      [min + 2 * segment, '#ef7d51'],
                      [min + 3 * segment, '#ad3416'],
                      [max - segment, '#b31817']                    
                  ],
                },
                'fill-opacity': 0.6,
                'fill-outline-color': '#000',
              },
              filter: ['==', '$type', 'Polygon'],
            })
          }
          if (map.getLayer('average-grid')) {
            // Change the cursor to a pointer when the mouse is over the places layer.
            map.on('mouseenter', 'average-grid', function() {
              map.getCanvas().style.cursor = 'pointer';
            });

            // Change it back to a pointer when it leaves.
            map.on('mouseleave', 'average-grid', function() {
              map.getCanvas().style.cursor = '';
            });
            map.on('click', 'average-grid', (e) => {
              
              const center = turf.center(e.features[0].geometry).geometry.coordinates;
              
              const popupHTML = ReactDOMServer.renderToStaticMarkup(
                <div>
                  <div>{this.state.metric} </div>
                  <div>Average: {e.features[0].properties.average.toFixed(2)} </div>
                </div>,
              );
              const mapboxgl = require('../node_modules/mapbox-gl/dist/mapbox-gl.js');
              mapboxgl.accessToken = 'pk.eyJ1IjoiZGFuaWVsYmV0dGVyaWRnZSIsImEiOiJjaWY3bjZqazcwc3IzczdrcmU1NjJ1czdnIn0.Xr0sZHMxs6Fvp7lzmmtJSg';
              if (!this.state.popup) {
                const popup = new mapboxgl.Popup()
                    .setLngLat(center)
                    .setHTML(
                      popupHTML,
                    )
                    .addTo(map);
                
                this.setState(() => {
                  return { 'popup': popup};
                });
              }
              this.state.popup.on('close', () => {
                this.setState(() => {
                  return { popup: undefined };
                });
              });
            });
          }
        }
      }
    }
  }

  render() {
    const { loading, readings } = this.state;

    if (loading && !readings) {
      return <Loading />;
    }
    return (
      <div />
    );
  }
}

Grid.propTypes = propTypes;

Grid.defaultProps = defaultProps;

export default Grid;



// WEBPACK FOOTER //
// ./src/Grid.js